import {TabsPage} from './tabs/tabs'
/*********
 * 标签中心，主页导航目标声明
 *
 * ***********/
export const TABS_INDEX = [
  TabsPage
];



// WEBPACK FOOTER //
// ./src/pages/tabs/index.ts